export default "__VITE_ASSET__8YzJLR6t__"